import { notion } from "./notion";
import { sns } from "./sns";

import { environment } from "../utils/environment";

const mobileIsProd = environment.mobile.isProd;

const THUMBA_PROD_URL = "https://thumba.jp";
const THUMBA_STG_URL = "https://stg.thumba.jp";

// For web, use current origin; for mobile, use predefined URLs
const thumbaJp = environment.isBrowser ? window.location.origin : mobileIsProd ? THUMBA_PROD_URL : THUMBA_STG_URL;

const masentic = "https://masentic.com/";

export const links = {
  thumbaJp,
  lineContact: "https://lin.ee/PDo4CEx",
  safetyAndSecurity: `${THUMBA_PROD_URL}/media/216`,
  privacyPolicy: "https://masentic.notion.site/2aa33ce9a690815dbbc1dfd2ea51d3c1",
  termsOfService: "https://masentic.notion.site/2aa33ce9a69081ef8049f6120796b8af?pvs=74",
  withdrawal: `${thumbaJp}/withdrawal`,
  masentic,
  sns,
  notion,
};
